import React from "react";
import {BrowserRouter} from 'react-router-dom';

import { AuthProvider } from "./modules/Auth/hook";
import MaintenancePage from "./pages/MaintenancePage";
import Router from "./Router";
import './App.scss';

const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

const App: React.FC = () => {
  if (MAINTENANCE_MODE) return <MaintenancePage />;

  return (
    <BrowserRouter>
      <AuthProvider>
        <Router/>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
